import React from 'react';
import autosize from 'autosize';
import { createCustomInputClassName } from './customInputStyles';

interface TProps {
  name: string;
  placeholder: string;
  value?: string;
  invalid?: boolean;
  autoFocus?: boolean;
  testId?: string;
  maxLength?: number;
  onChange(event: React.ChangeEvent<HTMLTextAreaElement>): void;
}

export const CustomInputNativeTextAreaComponent: React.FC<TProps> = (props) => {
  const { invalid, testId, ...nativeProps } = props;

  const textAreaNodeRef = React.useRef<HTMLTextAreaElement>(null);

  React.useLayoutEffect(() => {
    const { current: textAreaNode } = textAreaNodeRef;

    if (textAreaNode) {
      autosize(textAreaNode);
    }
  }, []);

  return (
    <textarea
      {...nativeProps}
      ref={textAreaNodeRef}
      className={createCustomInputClassName('textarea')}
      data-invalid={invalid}
      data-testid={testId}
    />
  );
};
